<template>
  <main>
    <div class="py-4 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection :title="periode_active?.name || '-'">
            <div class="text-right">
              <!-- <div class="d-flex flex-row gap-3">
                <argon-button :outline="true">Kembali</argon-button>
                <argon-button>Kirim</argon-button>
              </div> -->

              <div class="d-flex gap-3">
                <router-link :to="{ name: 'Tracking Status' }">
                  <button class="btn btn-secondary">
                    Kembali
                  </button>
                </router-link>
                  <!-- v-if="status.includes('reject')" -->
                <router-link
                  v-if="status === 'reject_direct_supervisor'"
                  :to="{ name: 'Tracking Status Update KPI', params: { periode_id, realization_id, status } }"
                >
                  <button class="btn btn-secondary">
                    Ubah
                  </button>
                </router-link>
              </div>
            </div>
          </MetaSection>
        </GridCol>
        
        <GridCol :size="12">
          <form action="" @submit.prevent>
            <!-- <cards title="Form Realisasi KPI" useFooter> -->
              <!-- <template v-slot:footer>
                <div class="text-right">
                  <div class="d-flex flex-row-reverse gap-2">
                    <ArgonButton>Lanjutkan</ArgonButton>
                    <ArgonButton :to="{ name: 'Realisasi Target' }" isRouteLink outline>Batalkan</ArgonButton>
                  </div>
                </div>
              </template> -->

            <cards title="Form Realisasi KPI" :p="0" class="card--tabs">
              <tabbed-pane
                :tabs="tabs"
              >
                <div class="tab-pane fade show active p-4 pt-0"
                  id="pills-penilaian-kinerja"
                  role="tabpanel"
                  aria-labelledby="pills-penilaian-kinerja-tab"
                >
                  
                  <div class="mb-4 d-flex items-center justify-content-between">
                    <h5>Penilaian Kinerja</h5>
                    <!-- <span>
                      <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                    </span> -->
                  </div>

                  <template v-if="list_penilaian_kinerja?.catatan?.direct?.length > 0">
                    <ArgonAlert
                      v-for="item in list_penilaian_kinerja.catatan.direct"
                      :key="item"
                      title="Catatan Atasan 1"
                      color="primary"
                      :dismissible="false"
                    >
                      <p>{{ item?.catatan || '-' }}</p>
                    </ArgonAlert>
                  </template>

                  <template v-if="list_penilaian_kinerja?.catatan?.immediate?.length > 0">
                    <ArgonAlert
                      v-for="item in list_penilaian_kinerja.catatan.immediate"
                      :key="item"
                      title="Catatan Atasan 2"
                      color="primary"
                      :dismissible="false"
                    >
                      <p>{{ item?.catatan || '-' }}</p>
                    </ArgonAlert>
                  </template>

                  <template v-if="list_penilaian_kinerja?.realisasi_kinerja?.list_kpi?.length > 0">
                    <form-group
                      v-for="(item, index) in list_penilaian_kinerja?.realisasi_kinerja.list_kpi"
                      :key="index"
                      :label="item?.kpi || '-'"
                      :hint="item?.sub_jumlah || item?.sub_jumlah === 0 ? item?.sub_jumlah : '-'"
                    >
                      <div class="table-responsive">
                        <table class="table align-middle border border-1 border-light">
                          <thead class="table-light">
                            <tr>
                              <th scope="col">Sub KPI</th>
                              <th scope="col">Target</th>
                              <th scope="col">Bobot</th>
                              <th scope="col">Realisasi</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="sub_item in item.sub_kpi"
                              :key="sub_item"
                              class="border border-bottom-1 border-light"
                            >
                              <td>
                                <p>{{ sub_item?.nama_aspek_kpi || '-' }}</p>
                                <p v-if="sub_item?.catatan" class="text-xs">{{ sub_item?.catatan || '-' }}</p>
                              </td>
                              <td width="150">
                                <p>
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      style: 'currency',
                                      currency: 'IDR',
                                      minimumFractionDigits: 0,
                                    }).format(sub_item?.target || '0')
                                  }}
                                </p>
                              </td>
                              <td width="100">
                                <p>{{ sub_item?.bobot ? sub_item.bobot +'%' : '-' }}</p>
                              </td>
                              <td width="150">
                                <p>
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      style: 'currency',
                                      currency: 'IDR',
                                      minimumFractionDigits: 0,
                                    }).format(sub_item?.realisasi || '0')
                                  }}
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </form-group>
                  </template>
                </div>

                <div class="tab-pane fade show p-4 pt-0"
                  id="pills-penugasan-khusus"
                  role="tabpanel"
                  aria-labelledby="pills-penugasan-khusus-tab"
                >
                  
                  <div class="mb-4 d-flex items-center justify-content-between">
                    <h5>Penugasan Khusus</h5>
                    <!-- <span>
                      <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                    </span> -->
                  </div>

                  <template v-if="list_penugasan_khusus?.catatan?.direct?.length > 0">
                    <ArgonAlert
                      v-for="item in list_penugasan_khusus.catatan.direct"
                      :key="item"
                      title="Catatan Atasan 1"
                      color="primary"
                      :dismissible="false"
                    >
                      <p>{{ item?.catatan || '-' }}</p>
                    </ArgonAlert>
                  </template>

                  <template v-if="list_penugasan_khusus?.catatan?.immediate?.length > 0">
                    <ArgonAlert
                      v-for="item in list_penugasan_khusus.catatan.immediate"
                      :key="item"
                      title="Catatan Atasan 2"
                      color="primary"
                      :dismissible="false"
                    >
                      <p>{{ item?.catatan || '-' }}</p>
                    </ArgonAlert>
                  </template>

                  <form-group>
                    <div class="table-responsive">
                      <table class="table align-middle border border-1 border-light">
                        <thead class="table-light">
                          <tr>
                            <th scope="col" colspan="2">Jenis Penugasan</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-if="list_penugasan_khusus?.penugasan?.length > 0">
                            <tr
                              v-for="(item) in list_penugasan_khusus?.penugasan"
                              :key="item"
                              class="border border-bottom-1 border-light"
                            >
                              <td colspan="2">
                                <div class="py-3 px-3">{{ item?.name || '-' }}</div>
                              </td>
                            </tr>
                          </template>
                          <tr v-else>
                            <td colspan="2" class="text-center">-</td>
                          </tr>
                        </tbody>
                        <thead class="table-light">
                          <tr>
                            <th scope="col">Nilai Penugasan Khusus</th>
                            <!-- <th scope="col">{{ list_penugasan_khusus?.nilai || list_penugasan_khusus?.nilai === 0 ? list_penugasan_khusus.nilai : '-'  }}</th> -->
                            <th scope="col">{{ list_penugasan_khusus?.penugasan?.length > 0 ? '0.25' : '0' }}</th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </form-group>
                </div>

                <div class="tab-pane fade show p-4 pt-0"
                  v-if="status !== 'reject_direct_supervisor'"
                  id="pills-pengurangan"
                  role="tabpanel"
                  aria-labelledby="pills-pengurangan-tab"
                >
                  
                  <div class="mb-4 d-flex items-center justify-content-between">
                    <h5>Pengurangan</h5>
                    <!-- <span>
                      <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                    </span> -->
                  </div>

                  <template v-if="list_pengurangan?.catatan?.direct?.length > 0">
                    <ArgonAlert
                      v-for="item in list_pengurangan.catatan.direct"
                      :key="item"
                      title="Catatan Atasan 1"
                      color="primary"
                      :dismissible="false"
                    >
                      <p>{{ item?.catatan || '-' }}</p>
                    </ArgonAlert>
                  </template>

                  <template v-if="list_pengurangan?.catatan?.immediate?.length > 0">
                    <ArgonAlert
                      v-for="item in list_pengurangan.catatan.immediate"
                      :key="item"
                      title="Catatan Atasan 2"
                      color="primary"
                      :dismissible="false"
                    >
                      <p>{{ item?.catatan || '-' }}</p>
                    </ArgonAlert>
                  </template>

                  <form-group>
                    <div class="table-responsive">
                      <table class="table align-middle border border-1 border-light">
                        <thead class="table-light">
                          <tr>
                            <th scope="col">Tingkat Permasalahan</th>
                            <th scope="col">Jumlah</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-if="list_pengurangan?.pengurangan?.length > 0">
                            <tr
                              v-for="(item) in list_pengurangan?.pengurangan"
                              :key="item"
                              class="border border-bottom-1 border-light"
                            >
                              <td>
                                <div class="py-3 px-3">{{ item?.tingkat_permasalahan || '-' }}</div>
                              </td>
                              <td width="10">{{ item?.jumlah_permasalahan || item?.jumlah_permasalahan === 0 ? item.jumlah_permasalahan : '-' }}</td>
                            </tr>
                          </template>
                          <tr v-else>
                            <td colspan="2" class="text-center">-</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </form-group>
                </div>

                <div class="tab-pane fade show p-4 pt-0"
                  id="pills-kompetensi"
                  role="tabpanel"
                  aria-labelledby="pills-kompetensi-tab"
                >
                  <template v-if="realisasi_kompetensi?.catatan?.direct?.length > 0">
                    <ArgonAlert
                      v-for="item in realisasi_kompetensi.catatan.direct"
                      :key="item"
                      title="Catatan Atasan 1"
                      color="primary"
                      :dismissible="false"
                    >
                      <p>{{ item?.catatan || '-' }}</p>
                    </ArgonAlert>
                  </template>

                  <template v-if="realisasi_kompetensi?.catatan?.immediate?.length > 0">
                    <ArgonAlert
                      v-for="item in realisasi_kompetensi.catatan.immediate"
                      :key="item"
                      title="Catatan Atasan 2"
                      color="primary"
                      :dismissible="false"
                    >
                      <p>{{ item?.catatan || '-' }}</p>
                    </ArgonAlert>
                  </template>
                  
                  <template v-if="list_kompetensi_inti.length > 0">
                    <div class="mb-2 d-flex items-center justify-content-between">
                      <h5>Kompetensi Inti</h5>
                      <!-- <span>
                        <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                      </span> -->
                    </div>

                    <!-- <div class="rounded-2 border border-1 p-3 mb-4"> -->
                    <div
                      v-for="item in list_kompetensi_inti"
                      :key="item"
                    >
                      <div class="d-flex justify-content-between items-center">
                        <h6 class="mt-2">{{ item?.name || '-' }}</h6>
                      </div>

                      <table class="table align-middle border border-1 border-light">
                        <thead class="table-light">
                          <tr>
                            <th scope="col">Level</th>
                            <th scope="col">Deskripsi</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <td width="100">
                              <span class="px-2">{{ item.nilai }}</span>
                            </td>
                            <td>
                              <!-- <p class="mt-3 text-wrap">{{ item.list_kompetensi?.['level'+ item.nilai] || '-' }}</p> -->
                              <p class="mt-3 text-wrap">{{ item?.['level'+ item.nilai] || '-' }}</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </template>

                  <template v-if="list_kompetensi_manajerial.length > 0">
                    <hr class="mt-5 mb-4">
                    <div class="mb-2 d-flex items-center justify-content-between">
                      <h5>Kompetensi Manajerial</h5>
                      <!-- <span>
                        <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                      </span> -->
                    </div>

                    <!-- <div class="rounded-2 border border-1 p-3 mb-4"> -->
                    <div
                      v-for="item in list_kompetensi_manajerial"
                      :key="item"
                    >
                      <div class="d-flex justify-content-between items-center">
                        <h6 class="mt-2">{{ item?.name || '-' }}</h6>
                      </div>

                      <table class="table align-middle border border-1 border-light">
                        <thead class="table-light">
                          <tr>
                            <th scope="col">Level</th>
                            <th scope="col">Deskripsi</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <td width="100">
                              <span class="px-2">{{ item.nilai }}</span>
                            </td>
                            <td>
                              <!-- <p class="mt-3 text-wrap">{{ item.list_kompetensi?.['level'+ item.nilai] || '-' }}</p> -->
                              <p class="mt-3 text-wrap">{{ item?.['level'+ item.nilai] || '-' }}</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </template>

                  <!-- <form-group class="mt-3">
                    <div class="table-responsive">
                      <table class="table align-middle border border-1 border-light">
                        <thead class="table-light">
                          <tr>
                            <th scope="col" class="border-bottom-1 border-white">Jumlah</th>
                            <th scope="col" class="border-bottom-1 border-white">8</th>
                          </tr>
                          <tr>
                            <th scope="col">Nilai</th>
                            <th scope="col" width="60">3.5</th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </form-group> -->

                </div>

                <div class="tab-pane fade show p-4 pt-0"
                  id="pills-penilaian-akhir"
                  role="tabpanel"
                  aria-labelledby="pills-penilaian-akhir-tab"
                >
                  
                  <div class="mb-4 d-flex items-center justify-content-between">
                    <h5>Penilaian Akhir</h5>
                    <!-- <span>
                      <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                    </span> -->
                  </div>

                  <template v-if="data_penilaian_akhir?.catatan?.direct?.length > 0">
                    <ArgonAlert
                      v-for="item in data_penilaian_akhir.catatan.direct"
                      :key="item"
                      title="Catatan Atasan 1"
                      color="primary"
                      :dismissible="false"
                    >
                      <p>{{ item?.catatan || '-' }}</p>
                    </ArgonAlert>
                  </template>

                  <template v-if="data_penilaian_akhir?.catatan?.immediate?.length > 0">
                    <ArgonAlert
                      v-for="item in data_penilaian_akhir.catatan.immediate"
                      :key="item"
                      title="Catatan Atasan 2"
                      color="primary"
                      :dismissible="false"
                    >
                      <p>{{ item?.catatan || '-' }}</p>
                    </ArgonAlert>
                  </template>

                  <form-group>
                    <div class="table-responsive">
                      <table class="table align-middle border border-1 border-light">
                        <thead class="table-light">
                          <tr>
                            <th scope="col">Kategori</th>
                            <th scope="col" width="10">Nilai</th>
                            <th scope="col" width="10">Bobot</th>
                            <th scope="col" width="10">Nilai Akhir</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <div class="py-3 px-3">Rata-rata Nilai Kinerja</div>
                            </td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.nilai_kinerja?.average_kinerja || data_penilaian_akhir?.penilaian_akhir?.nilai_kinerja?.average_kinerja === 0 ? data_penilaian_akhir.penilaian_akhir.nilai_kinerja.average_kinerja : '-' }}</td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.nilai_kinerja?.bobot_kinerja || data_penilaian_akhir?.penilaian_akhir?.nilai_kinerja?.bobot_kinerja === 0 ? data_penilaian_akhir.penilaian_akhir.nilai_kinerja.bobot_kinerja +'%' : '-' }}</td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.nilai_kinerja?.nilai_akhir_kinerja || data_penilaian_akhir?.penilaian_akhir?.nilai_kinerja?.nilai_akhir_kinerja === 0 ? data_penilaian_akhir.penilaian_akhir.nilai_kinerja.nilai_akhir_kinerja : '-' }}</td>
                          </tr>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <div class="py-3 px-3">Rata-rata Perilaku Kompetensi</div>
                            </td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.kompetensi?.average_kompetensi || data_penilaian_akhir?.penilaian_akhir?.kompetensi?.average_kompetensi === 0 ? data_penilaian_akhir.penilaian_akhir.kompetensi.average_kompetensi : '-' }}</td>
                          <td>{{ data_penilaian_akhir?.penilaian_akhir?.kompetensi?.bobot_kompetensi || data_penilaian_akhir?.penilaian_akhir?.kompetensi?.bobot_kompetensi === 0 ? data_penilaian_akhir.penilaian_akhir.kompetensi.bobot_kompetensi +'%' : '-' }}</td>
                          <td>{{ data_penilaian_akhir?.penilaian_akhir?.kompetensi?.nilai_akhir_kompetensi || data_penilaian_akhir?.penilaian_akhir?.kompetensi?.nilai_akhir_kompetensi === 0 ? data_penilaian_akhir.penilaian_akhir.kompetensi.nilai_akhir_kompetensi : '-' }}</td>
                          </tr>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <td colspan="3">
                              <div class="py-3 px-3">Penugasan Khusus, Rangkap Jabatan, Inovasi & Kreatifitas</div>
                            </td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.penugasan_khusus || data_penilaian_akhir?.penilaian_akhir?.penugasan_khusus === 0 ? data_penilaian_akhir.penilaian_akhir.penugasan_khusus : '-' }}</td>
                          </tr>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <td colspan="3">
                              <div class="py-3 px-3">Faktor Pengurang KPI</div>
                            </td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.pengurang || data_penilaian_akhir?.penilaian_akhir?.pengurang === 0 ? data_penilaian_akhir.penilaian_akhir.pengurang : '-' }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </form-group>

                  <form-group>
                    <div class="table-responsive">
                      <table class="table align-middle border border-1 border-light">
                        <thead class="table-light">
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <th scope="col" class="border-bottom-1 border-white">Nilai Akhir</th>
                            <th scope="col" class="border-bottom-1 border-white" width="140">{{ data_penilaian_akhir?.penilaian_akhir?.nilai_akhir || data_penilaian_akhir?.penilaian_akhir?.nilai_akhir === 0 ? data_penilaian_akhir.penilaian_akhir.nilai_akhir : '-' }}</th>
                          </tr>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <th scope="col">Indeks</th>
                            <th scope="col">{{ data_penilaian_akhir?.penilaian_akhir?.indeks || '-' }}</th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </form-group>

                  <!-- <div class="d-flex justify-content-end gap-4">
                    <button type="button" class="btn btn-outline-secondary">Berikan Catatan</button>
                  </div> -->
                </div>

              </tabbed-pane>
            </cards>

          </form>
        </GridCol>
      </GridRow>
    </div>
  </main>
</template>
    
<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
// import FieldsetComponent from "@/components/FieldsetComponent.vue";
// import EmployeeApi from "@/repository/api/EmployeeApi";
// import Select2 from 'vue3-select2-component';
// import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";
import TabbedPane from "@/components/TabbedPane.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";
import MetaSection from '@/components/MetaSection.vue';
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
// import InputForm from "@/components/InputForm.vue";

import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";
// import LaporanPersonalApi from "@/repository/api/LaporanPersonalApi";
import PenilaianKpiApi from "@/repository/api/PenilaianKpiApi";
import KpiCompetenciesApi from "@/repository/api/KpiCompetenciesApi";

export default {
  name: "realisasi-target",
  components: {
    // FieldsetComponent,
    FormGroup,
    Cards,
    TabbedPane,
    // ArgonButton,
    ArgonAlert,
    MetaSection,
    GridRow,
    GridCol,
    // InputForm,
  },
  data() {
    return {
      data: {
        periode_id: "",
      },
      nip: "",
      kpiperiode: [],
      realisasikpi: [{}],
      timer: undefined,

      tabs: {
        'Penilaian Kinerja':true,
        'Penugasan Khusus':false,
        'Pengurangan':false,
        'Kompetensi':false,
        'Penilaian Akhir':false
      },

      employee: null,
      periode_active: null,

      list_penilaian_kinerja: [],
      list_penugasan_khusus: [],
      list_pengurangan: [],

      realisasi_kompetensi: null,
      list_kompetensi_inti: [],
      list_kompetensi_manajerial: [],

      data_penilaian_akhir: null,
    };
  },
  computed: {
    realization_id() {
      return this.$route.params?.realization_id;
    },
    periode_id() {
      return this.$route.params?.periode_id;
    },
    status() {
      return this.$route.params?.status;
    },
    // tabs() {
    //   let tabs = {
    //     'Penilaian Kinerja':true,
    //     'Penugasan Khusus':false,
    //     'Pengurangan':false,
    //     'Kompetensi':false,
    //     'Penilaian Akhir':false
    //   };

    //   // if (this.status === 'reject_direct_supervisor') {
    //   // if (this.status.includes('reject')) {
    //   if (!this.status === 'accept_immediate_supervisor') {
    //     delete tabs['Pengurangan'];
    //     delete tabs['Kompetensi'];

    //     console.log(this.status)
    //   }

    //   return tabs;
    // },
  },
  watch: {
    realization_id() {},
    periode_id() {},
    status() {},
    // tabs() {}
  },
  methods: {
    async getKpiPeriode() {
      // console.log('this.periode_id', this.periode_id)
      await KpiPeriodeApi.get(this.periode_id)
        .then((response) => {
          this.periode_active = response?.data || {};
        })
        .catch((err) => {
          console.log(err)
        });
    },

    // async getPenilaianKpi() {
    //   await LaporanPersonalApi.getDetailPenilaianKinerja({
    //     employee_id: this.employee_id,
    //     realization_id: this.realization_id,
    //   })
    //     .then((resp) => {
    //       this.list_penilaian_kinerja = resp?.data;
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     });
    // },

    // async getPenugasanKhusus() {
    //   await LaporanPersonalApi.getDetailPenugasanKhusus({
    //     employee_id: this.employee_id,
    //     realization_id: this.realization_id,
    //   })
    //     .then((resp) => {
    //       this.list_penugasan_khusus = resp?.data;
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     });
    // },

    // async getPengurangan() {
    //   await LaporanPersonalApi.getDetailPengurangan({
    //     employee_id: this.employee_id,
    //     realization_id: this.realization_id,
    //   })
    //     .then((resp) => {
    //       this.list_pengurangan = resp?.data;
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     });
    // },

    // async getKompetensi() {
    //   await LaporanPersonalApi.getDetailKompetensi({
    //     employee_id: this.employee_id,
    //     realization_id: this.realization_id,
    //   })
    //     .then((resp) => {
    //       const list = resp?.data;
    //       this.list_kompetensi = list;
    //       // console.log(list)

    //       if (list?.nilai_perkompetensi) {
            
    //         this.list_kompetensi_inti = list.nilai_perkompetensi.filter(item => item?.type === 'inti');
    //         this.list_kompetensi_manajerial = list.nilai_perkompetensi.filter(item => item?.type === 'manajerial');
    //       }

    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     });
    // },

    // async getPenilaianAkhir() {
    //   await LaporanPersonalApi.getDetailPenilaianAkhir({
    //     employee_id: this.employee_id,
    //     realization_id: this.realization_id,
    //   })
    //     .then((resp) => {
    //       this.data_penilaian_akhir = resp?.data || null;
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     });
    // },

    // ------------------------------------------------------------------------

    async getPenilaianKpi() {
      await PenilaianKpiApi.getDetailPenilaianKinerja({
        realization_id: this.realization_id,
      })
        .then((resp) => {
          this.list_penilaian_kinerja = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getPenugasanKhusus() {
      await PenilaianKpiApi.getDetailPenugasanKhusus({
        employee_id: this.employee_id,
        realization_id: this.realization_id,
      })
        .then((resp) => {
          this.list_penugasan_khusus = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getPengurangan() {
      await PenilaianKpiApi.getDetailPengurangan({
        employee_id: this.employee_id,
        realization_id: this.realization_id,
      })
        .then((resp) => {
          this.list_pengurangan = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getKompetensi() {
      // master kompetensi
      // await KpiCompetenciesApi.get()
      await KpiCompetenciesApi.getbyparam({
        limit: 100,
        status: 'active',
        type: this.employee.jabatan.jenis_kompetensi,
      })
        .then((resp) => {
          const list = resp?.data ? resp.data.map(item => { item.nilai = 0; return item; }) : [];
          // console.log(list)

          this.list_kompetensi_inti = list.filter(item => item?.type === 'inti');
          this.list_kompetensi_manajerial = list.filter(item => item?.type === 'manajerial');
        })
        .catch((err) => {
          console.log(err)
        });

      // saved value kompetensi is exist
      await PenilaianKpiApi.getDetailKompetensi({
        realization_id: this.realization_id,
        employee_id: this.employee_id,
      })
      .then((resp) => {
        // console.log(list)
          this.realisasi_kompetensi = resp?.data || null;

          // console.log('this.realisasi_kompetensi', this.realisasi_kompetensi)
          // console.log('this.list_kompetensi_inti', this.list_kompetensi_inti)
          // console.log('this.list_kompetensi_manajerial', this.list_kompetensi_manajerial)

          if (this.realisasi_kompetensi?.kompetensi?.[0]?.nilai_perkompetensi?.length > 0) {

            for (let index = 0; index < this.realisasi_kompetensi.kompetensi[0].nilai_perkompetensi.length; index++) {
              const kpi_saved = this.realisasi_kompetensi.kompetensi[0].nilai_perkompetensi[index];
              console.log(kpi_saved)
              
              const filter_kompetensi_inti = this.list_kompetensi_inti.filter(item => item.id === kpi_saved.kompetensi_id);
              if (filter_kompetensi_inti.length > 0) {
                const index_inti = this.list_kompetensi_inti.indexOf(filter_kompetensi_inti[0]);
                this.list_kompetensi_inti[index_inti].nilai = kpi_saved.nilai;
                
              } else {
                const filter_kompetensi_manajerial = this.list_kompetensi_manajerial.filter(item => item.id === kpi_saved.kompetensi_id);

                if (filter_kompetensi_manajerial.length > 0) {
                  const index_manajerial = this.list_kompetensi_manajerial.indexOf(filter_kompetensi_manajerial[0]);
                  this.list_kompetensi_manajerial[index_manajerial].nilai = kpi_saved.nilai;
                } 
              }
            }
          }

          console.log(this.list_kompetensi_inti)
          console.log(this.list_kompetensi_manajerial)
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getPenilaianAkhir() {
      // await PenilaianKpiApi.getDetailKompetensi({
      // await KpiCompetenciesApi.get()
      await PenilaianKpiApi.getPenilaianAkhir({
        employee_id: this.employee_id,
        realization_id: this.realization_id,
      })
        .then((resp) => {
          // console.log(resp?.data)
          this.data_penilaian_akhir = resp?.data || null;
        })
        .catch((err) => {
          console.log(err)
          // this.data_penilaian_akhir = err?.response?.data || null;
        });
    },

    // async getData() {
    //   this.$store.state.loading = true;
      
    //   try {

    //     await this.getEmployee();
    //     await this.getPenilaianKpi();
    //     await this.getPenugasanKhusus();
    //     await this.getPengurangan();
    //     await this.getKompetensi();

    //     await this.getPenilaianAkhir()

    //     this.$store.state.loading = false;
        
    //   } catch (error) {
    //     console.log(error)
    //     this.$store.state.loading = false;
    //   }
    // },
  },
  async mounted() {
    this.$store.state.loading = true;
    await this.getSessionUser();
    this.employee_id = this.$store.state?.sessionUser?.employee?.id || '';
    this.employee = this.$store.state?.sessionUser?.employee;
    await this.getKpiPeriode();
    await this.getPenilaianKpi();
    await this.getPenugasanKhusus();

    // if (this.status.includes('reject')) {
    // if (this.status === 'accept_immediate_supervisor') {
    //   await this.getKompetensi();
    // } else {
    //   delete this.tabs.Kompetensi;
    // }

    if (this.status !== 'accept_immediate_supervisor') {
      delete this.tabs['Pengurangan'];
      delete this.tabs['Kompetensi'];
      delete this.tabs['Penilaian Akhir'];

    } else {
      await this.getPengurangan();
      await this.getKompetensi();
      await this.getPenilaianAkhir();
    }
    
    this.$store.state.loading = false;
  },
};
</script>
    